import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/Hooks/useAppRedux';
import { clearNavigationPath } from '@/Slices/AccountSlice';

/**
 * NavigationHandler component
 * Handles navigation triggered by Redux actions
 */
const NavigationHandler = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const navigationPath = useAppSelector((state) => state.account.navigationPath);

  useEffect(() => {
    if (navigationPath) {
      navigate(navigationPath);
      dispatch(clearNavigationPath());
    }
  }, [navigationPath, navigate, dispatch]);

  return null;
};

export default NavigationHandler;
